import React from 'react'
import { css } from 'aphrodite'
import { Row, Col } from 'reactstrap'

import style from './style'
import styleB from '../../style'

import ScrollArea from '../../../partials/ScrollArea'

export const RevenueTable = props => {
  const _report = [
    ...props.revenue
      .slice()
      .reduce((arr, r) => [...arr, ...r.report], [])
      .reduce((arr, r) => {
        const index = arr.findIndex(_r => r.date === _r.date)
        return [
          ...(index > -1
            ? [
                ...arr.slice(0, index),
                { ...arr[index], amount: +arr[index].amount + +r.amount },
                ...arr.slice(index + 1)
              ]
            : [...arr, { ...r, _dType: 'revenue' }])
        ]
      }, []),
    ...props.stats.reduce((arr, r) => {
      const index = arr.findIndex(_r => r.date === _r.date)
      return [
        ...(index > -1
          ? [
              ...arr.slice(0, index),
              {
                ...arr[index],
                queries: +arr[index].queries + +r.queries,
                clicks: +arr[index].clicks + +r.clicks,
                impressions: +arr[index].impressions + +r.impressions
              },
              ...arr.slice(index + 1)
            ]
          : [...arr, { ...r, _dType: 'stats' }])
      ]
    }, [])
  ]
    .reduce((arr, item) => {
      const _iDateStr = item.date.split('-')
      _iDateStr[1] = +_iDateStr[1] - 1

      const _iDate = new Date(..._iDateStr)
      const currItemIndex = arr.findIndex(_item => {
        const __iDateStr = _item.date.split('-')
        __iDateStr[1] = +__iDateStr[1] - 1
        const __iDate = new Date(...__iDateStr)

        return (
          _iDate.getUTCDate() === __iDate.getUTCDate() &&
          _iDate.getUTCMonth() === __iDate.getUTCMonth() &&
          _iDate.getUTCFullYear() === __iDate.getUTCFullYear()
        )
      })

      return [
        ...(currItemIndex > -1
          ? [
              ...arr.slice(0, currItemIndex),
              {
                ...(item._dType === 'revenue'
                  ? {
                      ...arr[currItemIndex],
                      revenue: item.amount
                    }
                  : {
                      ...arr[currItemIndex],
                      ...item
                    })
              },
              ...arr.slice(currItemIndex + 1)
            ]
          : [
              ...(item._dType === 'revenue'
                ? [...arr, { date: item.date, revenue: item.amount }]
                : [...arr, { ...item, revenue: 0 }])
            ])
      ]
    }, [])
    .sort(
      (a, b) =>
        new Date(Date.UTC(...a.date.split('-'))).getTime() -
        new Date(Date.UTC(...b.date.split('-'))).getTime()
    )

  return (
    <Row>
      <Col
        className={css(
          style.list.wrapper,
          style[props.theme.name] ? style[props.theme.name].list.wrapper : null
        )}
      >
        <Row>
          <Col key={1}>
            <h3 className={css(styleB.headers.h3)}>Daily Statistics</h3>
          </Col>
        </Row>
        <Row>
          <ScrollArea
            key={2}
            style={{
              height: `200px`
            }}
          >
            <Col>
              <HeaderRow theme={props.theme} />
              {_report.map((item, index) => (
                <RevenueRow
                  theme={props.theme}
                  key={`${index}_${item.id}`}
                  report={item}
                  active={props.active}
                />
              ))}
            </Col>
          </ScrollArea>
        </Row>
      </Col>
    </Row>
  )
}

export const HeaderRow = props => {
  return (
    <Row
      className={css(
        style.list.header,
        style[props.theme.name] ? style[props.theme.name].list.header : null
      )}
    >
      <Col>
        <Row>
          <Col>
            <span
              className={css(
                style.item.span,
                style.item.headerSpan,
                style.item.spanCenter,
                style[props.theme.name]
                  ? style[props.theme.name].item.span
                  : null
              )}
            >
              date
            </span>
          </Col>
          <Col className={`d-none d-lg-block`}>
            <span
              className={css(
                style.item.span,
                style.item.headerSpan,
                style.item.spanCenter,
                style[props.theme.name]
                  ? style[props.theme.name].item.span
                  : null
              )}
            >
              queries
            </span>
          </Col>
          <Col>
            <span
              className={css(
                style.item.span,
                style.item.headerSpan,
                style.item.spanCenter,
                style[props.theme.name]
                  ? style[props.theme.name].item.span
                  : null
              )}
            >
              impressions
            </span>
          </Col>
          <Col className={`d-none d-lg-block`}>
            <span
              className={css(
                style.item.span,
                style.item.headerSpan,
                style.item.spanCenter,
                style[props.theme.name]
                  ? style[props.theme.name].item.span
                  : null
              )}
            >
              clicks
            </span>
          </Col>
          <Col>
            <span
              className={css(
                style.item.span,
                style.item.headerSpan,
                style.item.spanCenter,
                style[props.theme.name]
                  ? style[props.theme.name].item.span
                  : null
              )}
            >
              amount
            </span>
          </Col>
        </Row>
      </Col>
    </Row>
  )
}

export const RevenueRow = props => {
  const dateArr = props.report.date.split('-')

  return (
    <Row
      data-id={props.report.id}
      className={css(
        style.list.row,
        style[props.theme.name] ? style[props.theme.name].list.row : null
      )}
    >
      <Col>
        <Row>
          <Col>
            <span
              className={css(
                style.item.span,
                style.item.spanCenter,
                style[props.theme.name]
                  ? style[props.theme.name].item.span
                  : null
              )}
            >
              {`${dateArr[1]}/${dateArr[2]}/${dateArr[0]}`}
            </span>
          </Col>
          <Col className={`d-none d-lg-block`}>
            <span
              className={css(
                style.item.span,
                style.item.spanCenter,
                style[props.theme.name]
                  ? style[props.theme.name].item.span
                  : null
              )}
            >
              {props.report.queries || '--'}
            </span>
          </Col>
          <Col>
            <span
              className={css(
                style.item.span,
                style.item.spanCenter,
                style[props.theme.name]
                  ? style[props.theme.name].item.span
                  : null
              )}
            >
              {props.report.impressions || '--'}
            </span>
          </Col>
          <Col className={`d-none d-lg-block`}>
            <span
              className={css(
                style.item.span,
                style.item.spanCenter,
                style[props.theme.name]
                  ? style[props.theme.name].item.span
                  : null
              )}
            >
              {props.report.clicks || '--'}
            </span>
          </Col>
          <Col>
            <span
              className={css(
                style.item.span,
                style.item.spanCenter,
                style[props.theme.name]
                  ? style[props.theme.name].item.span
                  : null
              )}
            >
              {props.report.revenue >= 0
                ? `$${props.report.revenue.toFixed(2)}`
                : `-$${Math.abs(props.report.revenue).toFixed(2)}`}
            </span>
          </Col>
        </Row>
      </Col>
    </Row>
  )
}

export default RevenueTable



// WEBPACK FOOTER //
// ./src/components/Statistics/partials/RevenueTable/index.js